// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Roadmap_roadmapSection__ntyE9 {
    background-color: #fff;
    padding-bottom: 100px;
    position: relative;
}

.Roadmap_roadmapSection__ntyE9::before {
    content: '';
    position: absolute;
    left: 0;
    top: -1px;
    width: 40px;
    height: 40px;
    background-color: #040404; 
    clip-path: polygon(0 0, 100% 0, 0 100%);
}

.Roadmap_wrapper__omaGh {
    width: 100%;
}

.Roadmap_container__y-WSQ {
    max-width: 1600px;
    margin: 0 auto;
    max-width: 80vw;
}

.Roadmap_roadmapLayout__iCGmj {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 250vh;
    position: relative;
}

.Roadmap_roadmapHeader__Ce968 {
    max-width: 28vw;
    position: sticky;
    top: 25vh;
    margin-top: 15vh;
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}
.Roadmap_roadmapHeader__Ce968.Roadmap_visible__jD3BX {
    opacity: 1;
    transform: translateY(0);
}

.Roadmap_roadmapTitle__Tofle {
    font-size: 3.2vw;
    font-weight: 600;
}

.Roadmap_emphasisText__lMY5s {
    color: #000;
    line-height: 1.2;
    display: block;
    white-space: normal; 
    word-wrap: break-word;
}

.Roadmap_roadmapDescription__QTxAX {
    font-size: 18px;
    color: #000;
    opacity: 0;
    margin-top: 2vw;
    transform: translateY(20px);
    transition: opacity 0.6s ease-out 0.6s, transform 0.6s ease-out 0.6s;
}
.Roadmap_roadmapHeader__Ce968.Roadmap_visible__jD3BX .Roadmap_roadmapDescription__QTxAX {
    opacity: 1;
    transform: translateY(0);
}

.Roadmap_timelineContainer__UFE9w {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 10vw;
    height: 230vh;
    padding: 15vh 0;
    position: relative;
}

.Roadmap_timelineMarker__18JM7 {
    z-index: 2;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.5vw;
    height: 3.5vw;
    position: sticky;
    top: 40vh;
}
.Roadmap_markerRing__nZbYR {
    border: 1px solid #000;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2vw;
    height: 2vw;
}
.Roadmap_markerDot__BRUJn {
    background-color: #000;
    width: 0.2vw;
    height: 0.2vw;
}

.Roadmap_timelineBar__brmHy {
    width: 1px;
    background: #000;
    position: absolute;
    top: 15vh;
    bottom: 0;
}

.Roadmap_timelineProgress__Rbi3x {
    width: 100%;
    height: 0;
    background-color: #000;
    transition: height 1s ease;
}
.Roadmap_timelineProgress__Rbi3x.Roadmap_visible__jD3BX {
    height: 100%;
}

.Roadmap_milestonesContainer__lYJdw {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 190vh;
    padding: 50vh 0 10vh;
}

.Roadmap_milestoneItem__ISzK3 {
    display: flex;
    flex-direction: column;
    max-width: 30vw;
    gap: 16px;
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}
.Roadmap_milestoneItem__ISzK3.Roadmap_visible__jD3BX {
    opacity: 1;
    transform: translateY(0);
}

.Roadmap_milestonePeriod__J8rHu {
    font-size: 1.8vw;
    font-weight: 600;
}

.Roadmap_milestoneDetails__LU5ko {
    font-size: 1rem;
    color: #333;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.2s ease-out 0.2s, transform 0.2s ease-out 0.2s;
}
.Roadmap_milestoneItem__ISzK3.Roadmap_visible__jD3BX .Roadmap_milestoneDetails__LU5ko {
    opacity: 1;
    transform: translateY(0);
}

.Roadmap_achievementItem__bRfWB {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
    font-size: 16px;
}

.Roadmap_checkbox__HCL6y {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    border: 1px solid #000;
    border-radius: 4px;
    margin-right: 10px;
    margin-top: 2px;
    flex-shrink: 0;
}

.Roadmap_checkbox__HCL6y.Roadmap_completed__Wk9Ig {
    background-color: #000;
    color: #fff;
}

.Roadmap_checkmark__0ttVS {
    font-size: 12px;
    line-height: 1;
}

.Roadmap_achievementText__v15FK {
    flex: 1 1;
}

@media screen and (max-width: 768px) {
    .Roadmap_container__y-WSQ {
        max-width: none;
        width: 90vw;
    }
    
    .Roadmap_roadmapLayout__iCGmj {
        display: grid;
        grid-template-columns: 0.25fr 1fr;
        grid-template-rows: auto;
        gap: 16px;
    }
    
    .Roadmap_roadmapHeader__Ce968 {
        display: none;
    }
    
    .Roadmap_roadmapTitle__Tofle {
        font-size: 2rem;
    }
    
    .Roadmap_roadmapDescription__QTxAX {
        font-size: 16px;
    }
    
    .Roadmap_timelineMarker__18JM7 {
        width: 48px;
        height: 48px;
    }
    
    .Roadmap_markerRing__nZbYR {
        width: 42px;
        height: 42px;
    }
    
    .Roadmap_markerDot__BRUJn {
        width: 4px;
        height: 4px;
    }
    
    .Roadmap_milestoneItem__ISzK3 {
        max-width: none;
    }
    
    .Roadmap_milestonePeriod__J8rHu {
        font-size: 24px;
    }
    
    #Roadmap_header__C9ONo {
        grid-area: 1 / 2 / 2 / 3;
    }
    
    #Roadmap_timeline__aJGN2 {
        grid-area: 1 / 1 / 3 / 2;
    }
    
    #Roadmap_milestones__EVnz8 {
        grid-area: 2 / 2 / 3 / 3;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/Sections/Roadmap/Roadmap.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B,0DAA0D;AAC9D;AACA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,UAAU;IACV,eAAe;IACf,2BAA2B;IAC3B,oEAAoE;AACxE;AACA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,0DAA0D;AAC9D;AACA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,UAAU;IACV,2BAA2B;IAC3B,oEAAoE;AACxE;AACA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;QACb,iCAAiC;QACjC,wBAAwB;QACxB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".roadmapSection {\n    background-color: #fff;\n    padding-bottom: 100px;\n    position: relative;\n}\n\n.roadmapSection::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: -1px;\n    width: 40px;\n    height: 40px;\n    background-color: #040404; \n    clip-path: polygon(0 0, 100% 0, 0 100%);\n}\n\n.wrapper {\n    width: 100%;\n}\n\n.container {\n    max-width: 1600px;\n    margin: 0 auto;\n    max-width: 80vw;\n}\n\n.roadmapLayout {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    height: 250vh;\n    position: relative;\n}\n\n.roadmapHeader {\n    max-width: 28vw;\n    position: sticky;\n    top: 25vh;\n    margin-top: 15vh;\n    opacity: 0;\n    transform: translateY(30px);\n    transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n}\n.roadmapHeader.visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.roadmapTitle {\n    font-size: 3.2vw;\n    font-weight: 600;\n}\n\n.emphasisText {\n    color: #000;\n    line-height: 1.2;\n    display: block;\n    white-space: normal; \n    word-wrap: break-word;\n}\n\n.roadmapDescription {\n    font-size: 18px;\n    color: #000;\n    opacity: 0;\n    margin-top: 2vw;\n    transform: translateY(20px);\n    transition: opacity 0.6s ease-out 0.6s, transform 0.6s ease-out 0.6s;\n}\n.roadmapHeader.visible .roadmapDescription {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.timelineContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 10vw;\n    height: 230vh;\n    padding: 15vh 0;\n    position: relative;\n}\n\n.timelineMarker {\n    z-index: 2;\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 3.5vw;\n    height: 3.5vw;\n    position: sticky;\n    top: 40vh;\n}\n.markerRing {\n    border: 1px solid #000;\n    border-radius: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 2vw;\n    height: 2vw;\n}\n.markerDot {\n    background-color: #000;\n    width: 0.2vw;\n    height: 0.2vw;\n}\n\n.timelineBar {\n    width: 1px;\n    background: #000;\n    position: absolute;\n    top: 15vh;\n    bottom: 0;\n}\n\n.timelineProgress {\n    width: 100%;\n    height: 0;\n    background-color: #000;\n    transition: height 1s ease;\n}\n.timelineProgress.visible {\n    height: 100%;\n}\n\n.milestonesContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 190vh;\n    padding: 50vh 0 10vh;\n}\n\n.milestoneItem {\n    display: flex;\n    flex-direction: column;\n    max-width: 30vw;\n    gap: 16px;\n    opacity: 0;\n    transform: translateY(30px);\n    transition: opacity 0.2s ease-out, transform 0.2s ease-out;\n}\n.milestoneItem.visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.milestonePeriod {\n    font-size: 1.8vw;\n    font-weight: 600;\n}\n\n.milestoneDetails {\n    font-size: 1rem;\n    color: #333;\n    opacity: 0;\n    transform: translateY(20px);\n    transition: opacity 0.2s ease-out 0.2s, transform 0.2s ease-out 0.2s;\n}\n.milestoneItem.visible .milestoneDetails {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.achievementItem {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 8px;\n    font-size: 16px;\n}\n\n.checkbox {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #000;\n    border-radius: 4px;\n    margin-right: 10px;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.checkbox.completed {\n    background-color: #000;\n    color: #fff;\n}\n\n.checkmark {\n    font-size: 12px;\n    line-height: 1;\n}\n\n.achievementText {\n    flex: 1;\n}\n\n@media screen and (max-width: 768px) {\n    .container {\n        max-width: none;\n        width: 90vw;\n    }\n    \n    .roadmapLayout {\n        display: grid;\n        grid-template-columns: 0.25fr 1fr;\n        grid-template-rows: auto;\n        gap: 16px;\n    }\n    \n    .roadmapHeader {\n        display: none;\n    }\n    \n    .roadmapTitle {\n        font-size: 2rem;\n    }\n    \n    .roadmapDescription {\n        font-size: 16px;\n    }\n    \n    .timelineMarker {\n        width: 48px;\n        height: 48px;\n    }\n    \n    .markerRing {\n        width: 42px;\n        height: 42px;\n    }\n    \n    .markerDot {\n        width: 4px;\n        height: 4px;\n    }\n    \n    .milestoneItem {\n        max-width: none;\n    }\n    \n    .milestonePeriod {\n        font-size: 24px;\n    }\n    \n    #header {\n        grid-area: 1 / 2 / 2 / 3;\n    }\n    \n    #timeline {\n        grid-area: 1 / 1 / 3 / 2;\n    }\n    \n    #milestones {\n        grid-area: 2 / 2 / 3 / 3;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roadmapSection": `Roadmap_roadmapSection__ntyE9`,
	"wrapper": `Roadmap_wrapper__omaGh`,
	"container": `Roadmap_container__y-WSQ`,
	"roadmapLayout": `Roadmap_roadmapLayout__iCGmj`,
	"roadmapHeader": `Roadmap_roadmapHeader__Ce968`,
	"visible": `Roadmap_visible__jD3BX`,
	"roadmapTitle": `Roadmap_roadmapTitle__Tofle`,
	"emphasisText": `Roadmap_emphasisText__lMY5s`,
	"roadmapDescription": `Roadmap_roadmapDescription__QTxAX`,
	"timelineContainer": `Roadmap_timelineContainer__UFE9w`,
	"timelineMarker": `Roadmap_timelineMarker__18JM7`,
	"markerRing": `Roadmap_markerRing__nZbYR`,
	"markerDot": `Roadmap_markerDot__BRUJn`,
	"timelineBar": `Roadmap_timelineBar__brmHy`,
	"timelineProgress": `Roadmap_timelineProgress__Rbi3x`,
	"milestonesContainer": `Roadmap_milestonesContainer__lYJdw`,
	"milestoneItem": `Roadmap_milestoneItem__ISzK3`,
	"milestonePeriod": `Roadmap_milestonePeriod__J8rHu`,
	"milestoneDetails": `Roadmap_milestoneDetails__LU5ko`,
	"achievementItem": `Roadmap_achievementItem__bRfWB`,
	"checkbox": `Roadmap_checkbox__HCL6y`,
	"completed": `Roadmap_completed__Wk9Ig`,
	"checkmark": `Roadmap_checkmark__0ttVS`,
	"achievementText": `Roadmap_achievementText__v15FK`,
	"header": `Roadmap_header__C9ONo`,
	"timeline": `Roadmap_timeline__aJGN2`,
	"milestones": `Roadmap_milestones__EVnz8`
};
export default ___CSS_LOADER_EXPORT___;
